module.exports = __webpack_public_path__ + "img/model_62.af5cdfcb.jpg";